import { createForm } from '../../../factories'

export default createForm(['name', 'description'])



// WEBPACK FOOTER //
// ./src/store/modules/groups/forms/store.js